const initSelectric = () => {
    // $('.js-selectric').selectric({
    //     nativeOnMobile: true,
    // })
    // $('.js-selectric-transparent').selectric({
    //     nativeOnMobile: true,
    // })
    $('.wpcf7-form select').selectric();
}